/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenericResponse } from '../../models/generic-response';

export interface UserLogout$Params {
}

export function userLogout(http: HttpClient, rootUrl: string, params?: UserLogout$Params, context?: HttpContext): Observable<StrictHttpResponse<GenericResponse>> {
  const rb = new RequestBuilder(rootUrl, userLogout.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenericResponse>;
    })
  );
}

userLogout.PATH = '/api/v1/auth/logout';
